import React from 'react';
import { ResetPasswordSuccess } from '@desquared/wave-components-library';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import { IsFromLoginStore } from '@/store/isFromLogin';

import styles from './NewPasswordSuccess.module.css';

export default function NewPasswordSuccess({ logo, successImage, type }) {
  const router = useRouter();
  const t = useTranslations('common');

  return (
    <div className={styles.container}>
      <ResetPasswordSuccess
        titleText={t('new_password.create_new_password')}
        description={t('new_password.create_new_password_description')}
        logo={logo}
        logoRedirect={router.locale === router.defaultLocale ? '/' : `/${router.locale}/`}
        image={successImage}
        successTitle={t('new_password.create_new_password_succes_message')}
        page={t('new_password.create_new_password_my_credentials')}
        seeMoreText={` ${t('new_password.create_new_password_see_more')} `}
        seemoreLink={
          router.locale === router.defaultLocale ? '/user/credentials' : `/${router.locale}/user/credentials`
        }
        seeMoreLinkText={t('new_password.create_new_password_here')}
        buttonText={t('new_password.create_new_password_start')}
        onButtonClick={
          process.env.hasStoreNecessary
            ? () =>
                router.push({
                  pathname: '/select-service',
                })
            : () => {
                IsFromLoginStore.update(true);
                router.push({
                  pathname: '/',
                });
              }
        }
        classOption={type === 1 || type === 2 ? styles.paddingContainer : styles.noPaddingContainer}
      />
    </div>
  );
}
